import { render } from "./HomeGalleryEmpty.vue?vue&type=template&id=935510d0"
import script from "./HomeGalleryEmpty.vue?vue&type=script&lang=js"
export * from "./HomeGalleryEmpty.vue?vue&type=script&lang=js"
script.render = render

export default script